export type PublicationKind = 'comment' | 'review';

export const COMMENT_LIST_SORT = {
  newest: 'createdAt:desc',
  popular: 'reactions:desc',
} as const;

export type CommentListSort = (typeof COMMENT_LIST_SORT)[keyof typeof COMMENT_LIST_SORT];
